module.exports = __webpack_public_path__ + "img/设备.1f827957.svg";